import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Fetch, hrLenseBaseUrl } from "../../shared/Fetch";
import { IModel } from "./ECI";
import { IECI } from "../../models/ECI";
import { EmptyECI } from "./EmptyECI";
import { EmptyFilter, Filter, IECIFilter } from "./Filter";
import { Search } from "../../shared/Search";
import { TableHistory } from "./TableHistory";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { Tag } from "primereact/tag";
import { Publish } from "../requirement/Publish";
import { Dialog } from "primereact/dialog";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { User } from "../jvConnect/User";
import { Client_Type } from "../../models/RequirementMast";
import { InterviewProcess } from "../../models/FDropdown";


interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IECI>, loading: boolean });
    const [search, setSearch] = useState<string | null>(null);
    const [filters, setFilters] = useState<IECIFilter>(EmptyFilter);
    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const dt = useRef<any>(null);

    const [tHistory, setTHistory] = useState({ singleData: {}, open: false } as { singleData: IECI, open: boolean });
    const [userModal, setUserModal] = useState({ open: false, data: null, type: null } as any);
    const [userModalData, setUserModalData] = useState({ data: null as { employeeId?: number, empCode?: string, phoneNumber?: string, whatsAppNumber?: string, personalEmail?: string } | null });
    const [reqModal, setreqModal] = useState({ open: false, data: null as any });
    const hideTHistory = () => {
        setTHistory({ singleData: {}, open: false });
    }

    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };

    useEffect(() => {
        loadTableData();
    }, [search, filters, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("ECI", "GET", null, `filter=${JSON.stringify(filters)}&search=${search}`, props.toast);
        if (response) {
            const data: Array<IECI> = await response.json();
            // console.log(data);
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyECI, tableData: undefined });
    };

    const openEdit = (rowData: IECI) => {
        props.setModal({ open: true, singleData: { ...EmptyECI, ecI_ID: rowData.ecI_ID, submission_ID: rowData.submission_ID, req_ID: rowData.req_ID }, tableData: rowData });
    };

    const openTHistory = (rowData: IECI) => {
        setTHistory({ singleData: rowData, open: true });
    }

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
                <React.Fragment>
                    {!_role.includes(45) && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 my-2" onClick={openNew} />}
                </React.Fragment> : ''
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage ECI</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setSearch} />
                {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
            </span>
        </div>
    );

    const ecI_Type_Name = (rowData: IECI) => {
        return ((rowData.ecI_Type_Name !== "Backout" && rowData.ecI_Type_Name !== "Confirmed" && rowData.ecI_Type_Name !== "ECI Canceled" && rowData.ecI_Type_Name !== "Candidate Not Available" && rowData.ecI_Type_Name !== "Rejected" && (rowData.sales_ID === loginObj.id || rowData.isSalesHead === true || _role.includes(1))) || (_role.includes(1)) ?
            <span className="cursor-pointer text-cyan-700 underline"
                onClick={() => openEdit(rowData)}>{rowData.ecI_Type_Name}</span>
            : <span>{rowData.ecI_Type_Name}</span>);
    };
    const ecIHistory = (rowData: IECI) => {
        return (
            <Button onClick={() => openTHistory(rowData)} icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-text" aria-label="History" />
        );
    };


    const req_Job_Title = (rowData: any) => {
        return rowData.rejected_Status === "Yes" ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="warning" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };

    const rowClass = (data: any) => {
        if (data.client_Type === Client_Type.Implementing_Partner) {
            return 'bg-pink-100 font-semibold';
        } else {
            return '';
        }
    };

    const getEmployeeDetails = async (empCode: string) => {
        const response = await fetch(`${hrLenseBaseUrl}/Tds_Slab/getempbycode?empCode=${empCode}`, { method: "GET" });
        if (response) {
            const data: { employeeId?: number, empCode?: string, phoneNumber?: string, whatsAppNumber?: string, personalEmail?: string } = await response.json();
            setUserModalData({ data });
        }
    }



    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IECIFilter) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
                rowClassName={rowClass}

            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable />
                {/* <Column field="salesmanager" header="Sales Manager" sortable body={(rowData) => <p style={{ color: rowData.sales_Status ? "red" : "" }}>{rowData.salesmanager}</p>} /> */}

                <Column field="salesmanager" header="Sales Manager" sortable body={(r: IECI) => {
                    const showInfo = r?.recruiter_ID === loginObj.id || r?.sales_ID === loginObj.id;
                    return <User req={{
                        reqId: r.req_ID!,
                        subId: r.submission_ID,
                        eciId: r.ecI_ID,
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.ecI_Date ?? '',
                        userId: r.sales_ID ?? 0,
                        userName: r.salesmanager ?? '',
                    }} show={showInfo} />
                }} />
                <Column field="salesCompanyName" header="Sales Comp(Branch)" sortable />
                {/* <Column field="user_Name" header="Recruiter" sortable body={(rowData) => <p style={{ color: rowData.recruiter_Status ? "red" : "" }}>{rowData.user_Name}</p>} /> */}

                <Column field="user_Name" header="Recruiter" sortable body={(r: IECI) => {
                    const showInfo = r?.recruiter_ID === loginObj.id || r?.sales_ID === loginObj.id;
                    return <User req={{
                        reqId: r.req_ID!,
                        subId: r.submission_ID,
                        eciId: r.ecI_ID,
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.ecI_Date ?? '',
                        userId: r.recruiter_ID ?? 0,
                        userName: r.user_Name ?? '',
                    }} show={showInfo} />
                }} />
                <Column field="recruiterCompanyName" header="Recruiter Comp(Branch)" sortable />
                <Column field="consultant_Name" header="Consultant Name" sortable />
                <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} />
                <Column field="req_CategoryName" header="Skills Category" />
                {!_role.includes(19) && <Column field="thirdparty" header="Third Party" sortable />}
                {!((_role.includes(3) || _role.includes(4) || _role.includes(34) || _role.includes(40) || _role.includes(19) || _role.includes(23))) && <Column field="vendor_Company_Name" header="Prime Vendor" sortable />}
                {!_role.includes(40) || _role.includes(19) && <Column field="ecI_Client" header="End Client" />}
                {/* <Column field="eciDate" header="Int. Date" sortable /> */}
                <Column field="eciDate" style={{ minWidth: '100px' }} header="Int. Date" body={(rowData) => safeFormatDate(rowData.eciDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="ecI_Time" header="Int. Time" />
                <Column field="litency" header="Latency" />
                <Column field="time_Zone_Name" header="Zone" sortable />
                <Column field="ecI_Type" header="Type" sortable body={(r: IECI) => InterviewProcess.find(f => f.id === r.ecI_Type)?.name ?? ""} />
                <Column field="ecI_Type_Name" header="Status" body={ecI_Type_Name} sortable />
                <Column field="rejection_Status" header="Rejection Status" hidden />
                <Column field="client_Type" header="Client Type" hidden body={(rowData: any) => rowData.client_Type ? Client_Type[rowData.client_Type] : ""} />
                <Column field="salesEmail" header="Sales Email" />
                <Column field="recEmail" header="Recruiter Email" />
                <Column hidden field="reason" header="Comment" />
                {!_role.includes(40) && <Column field="ecIHistory" header="ECI History" body={ecIHistory} />}
            </DataTable>
            <Dialog visible={userModal.open} onHide={() => {
                setUserModal({ open: false, data: null, type: null });
                setUserModalData({ data: null });
            }} header={`${userModal?.type || "User"} Details`} modal style={{ width: "30vw" }} >
                {userModal.data && (
                    <div className="p-fluid">
                        <div className="border-round surface-card p-4 shadow-2">
                            <div className="flex align-items-center mb-4"> <i className="pi pi-user text-primary text-xl mr-3" /> <div>
                                <div className="text-900 font-semibold text-lg">
                                    {userModal?.data?.name}
                                </div>
                                <div className="text-600 text-sm"> {userModal?.type} </div>
                            </div>
                            </div>
                            <div className="grid">
                                <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-envelope text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Professional Email</div>
                                        <div className="text-900 font-medium"> {userModal?.data?.email} </div>
                                    </div>
                                </div>
                                {userModalData?.data?.personalEmail && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-envelope text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Email/Hangout</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.personalEmail} </div>
                                    </div>
                                </div>}
                                {userModalData?.data?.phoneNumber && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-phone text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">Phone</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.phoneNumber} </div>
                                    </div>
                                </div>}
                                {userModalData?.data?.whatsAppNumber && <div className="col-12 flex align-items-center mb-3">
                                    <i className="pi pi-phone text-primary mr-3" />
                                    <div>
                                        <div className="text-600 text-sm">WhatsApp</div>
                                        <div className="text-900 font-medium"> {userModalData?.data?.whatsAppNumber} </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                )}
            </Dialog>
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setFilters={(filters: string | null) => setFilters(filters)} /> */}
            <TableHistory singleData={tHistory.singleData} open={tHistory.open} hideDialog={hideTHistory} toast={props.toast} />
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={() => setPublish({ open: false, singleData: {} })} toast={props.toast} />
        </>
    );
}
